import type { Tutorial } from '.';
import type { TutorialStep } from './tutorial.ruleset';
import { assertNever } from '../../utils';
import { getDynamicTestBucket } from 'src/replicant/getters/ab';
import ab from 'src/replicant/ruleset/ab';
import * as tutorialRuleset from './tutorial.ruleset';

export const tutorialGetters = (state: Tutorial.State) => ({
  isTutorialStepComplete: (step: TutorialStep) => {
    const { tutorial } = state;
    switch (step) {
      case 'basicGameplay':
        return tutorial.basicGameplayShown;

      case 'careForPets':
        return tutorial.careForPetsShown;

      case 'chatWithPets':
        return tutorial.chatWithPetsShown;

      case 'petsGetSick':
        return tutorial.petSickShown;

      case 'friendReferral':
        return tutorial.friendReferralShown;

      case 'profile':
        return tutorial.profileShown;

      case 'match3':
        return tutorial.match3Shown;

      case 'visitFriend':
        return tutorial.visitFriendShown;

      case 'adult':
        return tutorial.adult;

      case 'duoInvite':
        return tutorial.duoInvite;

      case 'duoInviteReceived':
        return tutorial.duoInviteReceived;

      default:
        assertNever(step);
    }
  },

  getTutorialReward: (step: TutorialStep) => tutorialRuleset.rewards[step],
});
